import { IconCalendar } from "@/Icon/Calendar";

const DateButton = ({
  value,
  onClick,
  disabled = false,
}: {
  value?: string;
  onClick: () => void;
  disabled?: boolean;
}) => {
  return (
    <button
      type="button"
      onClick={onClick}
      disabled={disabled}
      className="
          border border-gray-200 rounded-lg px-3 py-2 pr-5 text-sm
          focus:outline-none focus:ring-2 focus:ring-orange-200
          w-[140px] text-left relative bg-white
        "
    >
      {value || "날짜 선택"}
      <span className="absolute right-2 top-1/2 text-gray-400 -translate-y-1/2 pointer-events-none">
        <IconCalendar />
      </span>
    </button>
  );
};

export default DateButton;
